import React, {Component} from "react";
import Home from "../../../images/home.jpg"

class PreviousProjectCard extends Component{
    render(){
        return(
            <div className="project-card sec-bg br-10">
                <img src={Home} />
                <div>
                    <h4>{this.props.name}</h4>
                    <p className="sec-txt small-txt">{this.props.desc}</p>
                    <p className="prim-txt small-txt">Read More <i className="fas fa-angle-down"></i></p>
                    <div className="social-flex">
                        <i className="fab fa-twitter"></i>
                        <i className="fab fa-facebook-square"></i>
                        <i className="fab fa-whatsapp"></i>
                    </div>
                    <div className="rounds-flex countdown-widget">
                        <h4 className="sec-txt">Starts in: </h4>
                        <p>00</p>:
                        <p>00</p>:
                        <p>00</p>:
                        <p>00</p>
                    </div>
                    <button>Details</button>
                </div>
            </div>
        );
    }
}

export default PreviousProjectCard;